import React, { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Login from '../containers/Login/Login';
import { AuthContext } from '../context/AuthContext';
import { get as lodashGet, includes as lodashIncludes } from 'lodash';
const AuthLayout = () => {
    const { state } = useContext(AuthContext);
    const isTruegreen = lodashGet(state, 'user.customerId.trueGreen.enabled');
    const enabledLicense = lodashGet(state, 'user.customerId.enabledLicense');

    const getDefaultRedirect = () => {
        if (enabledLicense) {
            for (let licenseTypeId in enabledLicense) {
                const license = enabledLicense[licenseTypeId];
                if (license.enabled && license?.licenseType?.name === 'smartCharging') {
                    return `/smartCharging?licenseTypeId=${licenseTypeId}`;
                }
            }
        }
        return isTruegreen ? '/' : '/cfmdashboard';
    };

    return (
        <Switch>
            {state.isAuthorized ? (
                <Redirect to={getDefaultRedirect()} />
            ) : (
                <>
                    <Route path="/auth/login/:id" exact component={Login} />
                    <Route path="/auth/login" exact component={Login} />
                </>
            )}
        </Switch>
    );
};

export default AuthLayout;
